export const KEY_CODES = {
    ENTER: 13,
    COMMA: 188
}